module.exports = __webpack_public_path__ + "0a155db43fd329f140a2b68262fec662.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/smith--wesson-brands-inc.png
// module id = 1762
// module chunks = 0